/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Totp_Unenroll_Confirm_DescriptionInputs */

const fr_totp_unenroll_confirm_description = /** @type {(inputs: Totp_Unenroll_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre ton code TOTP pour confirmer la désactivation.`)
};

/**

* @param {Totp_Unenroll_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const totp_unenroll_confirm_description = /** @type {((inputs?: Totp_Unenroll_Confirm_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Totp_Unenroll_Confirm_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_totp_unenroll_confirm_description(inputs)
});